// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_Lkc","colMin":"styles_colMin__3J4GW"};